import { Component, Input, OnDestroy, TemplateRef, ViewChild, inject } from '@angular/core';

import { ModalService } from '@base/common/services/modal.service';

import { ACTION_CLICK, EVENT } from '@shared/tag/tag.interface';
import { TagService } from '@shared/tag/tag.service';

import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    standalone: true,
    imports: [],
})
export class ModalComponent implements OnDestroy {
    @ViewChild('customModalFooter') customModalFooter: TemplateRef<any>;
    @Input() title: string;
    @Input() tagEventImp: Record<string, string>;
    @Input() tagEventCTA: Record<string, string>;
    @Input() tagEventClose: Record<string, string>;

    public modalRef: ModalService;

    public tagService = inject(TagService);

    private ngUnsubscribe$ = new Subject();

    public ngOnInit(): void {
        this.sendTagInit();
        this.modalRef?.crossClicked.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(() => {
            this.sendTagClose();
        });
    }

    public ngAfterViewInit(): void {
        if (this.customModalFooter) {
            this.modalRef.modalComponentRef.instance.customModalFooter = this.customModalFooter;
        }
    }

    public ngOnDestroy(): void {
        this.ngUnsubscribe$.next(null);
        this.ngUnsubscribe$.complete();
    }

    public close(): void {
        this.sendTagAction();
        this.modalRef.close();
    }

    public sendTagClose(): void {
        this.tagService.send({
            ...this.tagEventClose,
            actionClic: ACTION_CLICK.SELECTION,
            event: EVENT.CLICK,
        });
    }

    private sendTagInit(): void {
        this.tagService.send({
            ...this.tagEventImp,
            actionClic: ACTION_CLICK.PRINTING,
            event: EVENT.PRINTING,
        });
    }

    private sendTagAction(): void {
        this.tagService.send({
            ...this.tagEventCTA,
            actionClic: ACTION_CLICK.SELECTION,
            event: EVENT.CLICK,
        });
    }
}
